// extracted by mini-css-extract-plugin
export default {"cardContainer":"cardContainer__wI542","hide":"hide__3JYrx","thumbnailContainer":"thumbnailContainer__9kmlg","descriptionContainer":"descriptionContainer__-2kZu"};